import { render, staticRenderFns } from "./RmcFeeTile.vue?vue&type=template&id=1c258b66&scoped=true&"
import script from "./RmcFeeTile.vue?vue&type=script&lang=js&"
export * from "./RmcFeeTile.vue?vue&type=script&lang=js&"
import style0 from "./RmcFeeTile.vue?vue&type=style&index=0&id=1c258b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c258b66",
  null
  
)

export default component.exports